import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Circle stroke math: circumference `C = 2πr`. Set `stroke-dasharray = C` and `stroke-dashoffset = C * (1 - p/100)`
 * so offset 0 = full ring. Foreground circle is rotated −90° so 0% starts at 12 o’clock.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'progress-ring-svg',
  category: 'loading',
  title: 'Progress ring (SVG)',
  description: 'Circular progress via stroke-dashoffset; numeric label in the center.',
  tags: [T.progress, T.svg],
  html: `<h2>Ring progress</h2>
<label class="lbl"><span>Percent</span><input type="range" id="pct" min="0" max="100" value="65" /></label>

<div class="wrap">
  <!-- Two circles same r: background track + foreground arc (#arc updated in JS) -->
  <svg viewBox="0 0 80 80" width="120" height="120" aria-hidden="true"><circle class="bg" cx="40" cy="40" r="34" fill="none"></circle><circle class="fg" id="arc" cx="40" cy="40" r="34" fill="none"></circle></svg>
  <!-- Absolutely centered over SVG -->
  <div class="center" id="lab">65%</div>
</div>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 0.75rem;
}

.lbl {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.5rem;
  max-width: 16rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--nogrok-preview-on-surface-variant);
}

.wrap {
  position: relative;
  width: 120px;
  height: 120px;
}

.wrap svg {
  display: block;
}

.wrap circle.bg {
  stroke: var(--nogrok-preview-surface-container-high);
  stroke-width: 8;
}

/* Foreground arc — stroke-dasharray / stroke-dashoffset set from JS */
.wrap circle.fg {
  stroke: var(--nogrok-preview-primary);
  stroke-width: 8;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: 40px 40px;
  transition: stroke-dashoffset 0.15s ease;
}

.center {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}`,
  js: `const R = 34
const C = 2 * Math.PI * R
const arc = document.getElementById('arc')
const pct = document.getElementById('pct')
const lab = document.getElementById('lab')

function setP(p) {
  const off = C * (1 - p / 100)
  if (arc instanceof SVGCircleElement) {
    arc.style.strokeDasharray = String(C)
    arc.style.strokeDashoffset = String(off)
  }
  if (lab) lab.textContent = Math.round(p) + '%'
}

function read() {
  const v = pct instanceof HTMLInputElement ? Number(pct.value) : 0
  setP(v)
}

pct?.addEventListener('input', read)
read()`,
}

export default preset
